import { inject, observer } from "mobx-react";
import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import Snackbar from "../components/Snackbar";
import { CMS_DESTINATION_LABEL } from "../utils/constants";

class ForgeSnackbar extends React.Component {
  render() {
    const { forgeSnackbarStore } = this.props;
    const { forgeLinks } = forgeSnackbarStore;
    const multiple = forgeLinks.length > 1;
    return (
      <Snackbar
        isOpen={forgeSnackbarStore.isOpen}
        handleClose={() => {
          forgeSnackbarStore.handleClose();
        }}
        message="Video has posted to forge!"
        actions={forgeLinks.map(link => (
          <Button
            key={link.destination}
            color="secondary"
            size="small"
            href={link.url}
            target="_blank"
          >
            {multiple
              ? `Go To ${CMS_DESTINATION_LABEL[link.destination]}`
              : "Go To Forge"}
          </Button>
        ))}
      />
    );
  }
}

ForgeSnackbar.propTypes = {
  forgeSnackbarStore: PropTypes.object.isRequired
};

export default inject("forgeSnackbarStore")(observer(ForgeSnackbar));



// WEBPACK FOOTER //
// ./src/containers/ForgeSnackbar.js